import type {AjaxService} from 'core/data-services/ajax.service';

export interface FondPermissions {
    showable: number[];
    editable: number[];
}

export class FondPermissionsDataService {
    public static serviceName = 'fondPermissionsDataService';

    private static readonly ROUTE = 'fond-permissions';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getUserFondPermissions(): Promise<FondPermissions> {
        return this.ajaxService
            .createRequest(FondPermissionsDataService.ROUTE)
            .get();
    }
}